export default "__VITE_ASSET__CSqPSNJc__"